import React, { useContext, useEffect, useState } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import { FullGridContext } from "../..";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import { AlertContext } from "~/App";
import api from "~/services/api";
import { toast } from "react-toastify";
import { format, parseISO } from "date-fns";

export default function GravityConciliation() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "date", asc: false };
  const defaultGridHeader = [
    {
      title: "Batch Number",
      name: "batch_number",
      type: "text",
      filter: false,
    },
    {
      title: "Date",
      name: "date",
      type: "text",
      filter: false,
    },
    {
      title: "Amount",
      name: "amount",
      type: "text",
      filter: false,
    },
    {
      title: "Items",
      name: "items",
      type: "text",
      filter: false,
    },
    {
      title: "Status",
      name: "status",
      type: "text",
      filter: true,
    },
  ];
  const [selected, setSelected] = useState([]);
  const { alertBox } = useContext(AlertContext);

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "gravity-conciliations"
  );

  useEffect(() => {
    setSearch("");
    setPage(1);
  }, []);

  async function loader() {
    setLoadingData(true);
    const data = await getData("gravityconciliations", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });
    if (!data) {
      return;
    }
    const gridDataValues = data.map((row, index) => {
      const {
        id,
        batch_number,
        date,
        amount,
        status,
        canceled_at,
        total_items,
        verified_items,
        items,
      } = row;

      const total = total_items ?? items?.length;
      const verified =
        verified_items ??
        items?.filter((item) => item.status === "Verified").length;
      const itemsLabel =
        total === undefined || verified === undefined
          ? "-"
          : `${verified}/${total}`;

      return {
        show: true,
        id,
        fields: [
          batch_number,
          format(parseISO(date), "MMMM do, yyyy"),
          amount?.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
          }),
          itemsLabel,
          status,
        ],
        canceled: canceled_at,
        page: Math.ceil((index + 1) / limit),
      };
    });
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    if (!opened) {
      loader();
    }
  }, [opened, filial, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
    />
  );
}
